import { render, staticRenderFns } from "./MenuNotificationsSettings.vue?vue&type=template&id=5165d757"
import script from "./MenuNotificationsSettings.vue?vue&type=script&lang=js"
export * from "./MenuNotificationsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports